import React from "react";
import clsx, { type ClassValue, } from "clsx";
import { twMerge, } from "tailwind-merge";

function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Mapeamento de Elevation do MUI para Tailwind Shadows
const elevationMap: Record<number, string> = {
  0: "shadow-none",
  1: "shadow-sm",
  2: "shadow",
  3: "shadow-md",
  4: "shadow-lg",
  5: "shadow-xl",
  6: "shadow-2xl",
  // O Tailwind não tem 24 níveis por padrão, mapeamos os restantes para o máximo ou customizamos
  ...Object.fromEntries(Array.from({ length: 18 }, (_, i) => [i + 7, "shadow-2xl"]))
};

interface PaperProps extends React.HTMLAttributes<HTMLDivElement> {
  component?: React.ElementType;
  square?: boolean;
  elevation?: number;
  variant?: "elevation" | "outlined";
  children?: React.ReactNode;
}

const Paper = React.forwardRef<HTMLDivElement, PaperProps>((props, ref) => {
  const {
    className,
    component: Component = "div",
    square = false,
    elevation = 1,
    variant = "elevation",
    ...other
  } = props;

  const classes = cn(
    // Estilos Base (Cor de fundo e texto padrão do MUI Paper)
    "bg-white text-slate-900 transition-shadow",

    // Arredondamento (square=false -> rounded-sm ou conforme seu theme)
    !square ? "rounded" : "rounded-none",

    // Variante Outlined
    variant === "outlined" && "border border-slate-200 shadow-none",

    // Variante Elevation
    variant === "elevation" && elevationMap[elevation],

    className
  );

  return <Component ref={ref} className={classes} {...other} />;
});

Paper.displayName = "Paper";

export default Paper;